export const fetchIsNavigationExpanded = (isExpanded) => dispatch => {
  dispatch({
    type: 'FETCH_IS_NAVIGATION_EXPANDED',
    payload: isExpanded,
  })
 }